export default __webpack_public_path__ + "static/media/web-desktop.01648cd0.svg";